import { License } from "../models/Customer";
import { LottolocaNumber } from "../models/grid-number.model";


export interface Awards {
    int: string[];
}



export interface Coordinates {
    Point: any;
}

export interface Option {
    description: string;
    coordinates: Point[];
}

export interface LotteryParamOption {
    description: string;
    coordinates: Point[];
}


export interface Options {
    Option: Option[];
}

export interface LotteryParam {
    description: string;
    options: Option[];
}

export interface AwardParam {
    description: string;
    awards: number[];
    jockerAwards: number[];
    amountDrawn:number;
    jockerAmountDrawn: number;
    index:number;
    
    awardLevelParams: AwardLevelParam[];
}

export interface AwardLevelParam {
    description: string;
    numberAwards: number[];
    jockerAwards: number[];
 
    level:number;
}

export interface ManualParam {
    description: string;
    title: string;
    link: string;
    order:number
}


export interface LotteryParams {
    LotteryParam: LotteryParam[];
}

export interface Point {
    X: number;
    Y: number;
}

export interface NumbersByBetOption {
    value: number;
    cost: number;
}


export interface Identify {
    Point: Point[];
}

export interface Key {

    int: string;
}



export interface Value {
    Point: Point;
}

export interface Item {
    key: Key;
    value: Value;
}

export interface Dictionary {
    item: Item[];
}


export interface Key2 {

    int: string;
}

export interface Point3 {
    X: string;
    Y: string;
}

export interface Value2 {
    Point: Point3;
}

export interface Item2 {
    key: Key2;
    value: Value2;
}

export interface Dictionary2 {
    item: Item2[];
}

export interface BlockCoordinate {
    dictionary: Dictionary2;
}

export interface Jocker
{
    key:number;
    name:string;
    values:string[];
}

export interface CardBlockPosition {
    x: number;
    y: number;
    Col: number;
    Row: number;
    ColsLength: number;
    RowsLength: number;
}

export interface ScreenCardBlockPosition {
    CardBlockPosition: CardBlockPosition[];
}

export interface CardBlockPosition2 {
    x: string;
    y: string;
    Col: string;
    Row: string;
    ColsLength: string;
    RowsLength: string;
}

export interface PrintTicketCardBlockPosition {
    CardBlockPosition: CardBlockPosition2;
}

export interface CardBlockPosition3 {
    x: string;
    y: string;
    Col: string;
    Row: string;
    ColsLength: string;
    RowsLength: string;
}

export interface PrintPaperCardBlockPosition {
    CardBlockPosition: CardBlockPosition3;
}

export class NumberCoordinate {
    public key: number;
    public point: Point;
}

export interface CardModel {
    id: string;
    Name: string;
    BmpCardLottery: string;
    NumberBetsByCard: number;
    lotteryParams: LotteryParam[];
    identify: Point[];
    numberCoordinates: NumberCoordinate[];
    blockCoordinates: NumberCoordinate[];
    jockerCoordinates: NumberCoordinate[];
    jockerBlockCoordinates: NumberCoordinate[];
    PaperPrintWidth: number;
    PaperPrintHeight: number;
    cols: number;
    rows: number;
    // colDist:number;
    // rowDist:number;
    // rectHeight:number;
    // rectWidth:number

    ScreenCardConfig: PrintCardConfig;
    PrintCardConfig: PrintCardConfig;
    PrintA4CardConfig: PrintCardConfig;
}

export class PrintCardConfig {
    printScaleFactor:number = 0;
    textFontHeigth: number = 0;
    textFontBold: boolean = false;
    textRectHeight: number = 0;
    textRectWidth: number = 0;
    textMarginLeft: number = 0;
    textMarginTop: number = 0;
    colDist: number = 0;
    rowDist: number = 0;
    rectHeight: number = 0;
    rectWidth: number = 0;
    topMargin: number = 0;
    leftMargin: number = 0;
    adjustTop: number = 0;
    adjustLeft: number = 0;
    blockPositions: CardBlockPosition[] = []
    mmToPixelsFactor: number = 0;
  paperPrintWidth: number = 0;
  paperPrintHeight: number = 0;
  cardsCols: number;
  cardsRows: number;
  displayAngle: number = 0;
  displayMobileAngle: number = 0;
}

export interface CustomerLottery {

    lastModified : Date;
}
export interface Lottery {
    JockerAmountDrawn: number;
    AmountDrawn: number;
    jockersByBet: NumbersByBetOption[];
    
    
    jockersGroupOptions: number[];
    jockersHeaderColsList: LottolocaNumber[];
    jockersBetTypes:  number[];
    jockersFrequencyStatistics: number;
    jockersFilterNumbersColumns: number;
    order: any;
    license: License;
 
    id: string;
    NumberList: LottolocaNumber[];
    headerColsList: LottolocaNumber[];
    // Awards: number[];
    // JockerAwards: number[];
    Name: string;
    ProductImage: string;
    JockerName: string;
    JockersName: string;
    GridNumbersColumns: number;
    filterNumbersColumns: number;
    GridNumbersRows: number;
    NumbersByBet: NumbersByBetOption[];
    DefaultCardModelId: string;
    FrequencyStatistics: number[];
    active: boolean;
    maxSelectNumbers:number;
    JockerList: Jocker[];

    GridJockersColumns: number;
    GridJockersRows: number;
    idealNumbersByGroup: number;
    awardParams: AwardParam[];
    awardLevelParams: AwardLevelParam[];
    manualParams: ManualParam[];
    hasLicense:boolean;

    betTypes: number[];

    groupOptions: number[];

    isFootballLottery: boolean;

}

export class CoverNumber
{
  public value:number;
  public group:string;
}




